export const FocusOnEvent = {
  mounted() {
    this.handleEvent("focus-search", () => {
      this.el.focus();
      this.el.select();
    });
    this.handleEvent("blur-search", () => {
      this.el.blur();
    });

    this.el.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        this.el.blur();
        return;
      }
      if (["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) {
        e.preventDefault();
        this.pushEvent("search_keydown", { key: e.key });
      }
    });
  },
};
